module.exports = __webpack_public_path__ + "img/logo-footer-6.55e676a5.png";